import {StaticAccountData} from './account';
import {ScoredAccount} from './scoredAccounts';
import {Tag} from './tags';
import {WithId} from './util';
import {KeyplayScoringSignal} from './signals';
import {CrmRecord} from './crm';
import {CrmEnrichedValueTimestamp} from './integrations/crm';
import {BaseFieldValue} from './fields/base';

export type ExportData = {
  tags?: WithId<Tag>[];
  scoringData?: {
    signals: KeyplayScoringSignal[];
  };
  crmRecord?: WithId<CrmRecord>;
  crmEnrichedValueTimestamps?: CrmEnrichedValueTimestamp[];
  scoredAccount?: WithId<ScoredAccount>;
  enrichedFields?: BaseFieldValue[];
  // HACK: Account isn't in shared yet
  account?: {staticData?: StaticAccountData};
};

export type WithStaticAccountData<T> = T & {
  staticAccountData?: StaticAccountData;
};

export const MaxClayExportSize = 5_000;
export const ClayExportRegex = /^https:\/\/api.clay.com/;
